import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { AccessSectionSchema } from "../../Schemas/Role";

interface Filter extends IFilterSchema {
  column: AccessSectionListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: AccessSectionListColumnSortable;
}

export enum AccessSectionListColumnFilterable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}
export enum AccessSectionListColumnSortable {
  ID = "id",
  CAPTION = "caption",
  CREATED_AT = "created_at",
}

export interface AccessSectionListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

export interface AccessSectionListResponseBody extends IResponseBody {
  data: {
    access_sections: AccessSectionSchema[];
  };
}

export class AccessSectionListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/account/access-sections`;
  }

  async send(
    queryStrings?: AccessSectionListQueryString
  ): Promise<AccessSectionListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: {
          count: 100,
          ...queryStrings,
        },
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
